<template>
  <div class="d-flex justify-content-between">
    <h2 class="pl-0">{{ title }}</h2>
    <TimetableProjectSwitch :school="school" />
  </div>
</template>

<script>
import TimetableProjectSwitch from 'src/components/management/TimetableProjectSwitch.vue'
import APIMixin from 'src/mixins/management/APIMixin.js'
export default {
  name: 'AdminHeader',
  components: { TimetableProjectSwitch },
  mixins: [APIMixin],
  props: {
    title: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped lang="scss">
h2 {
  padding-left: 20px;
}

@media (max-width: 768px) {
  h1 {
    font-size: pxtorem(27);
  }
}
</style>
